import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_lFznPiNLXdRO: {
	id: 'prd_lFznP2DEV2iNLXdRO'
	ident: 'prd_lFznPiNLXdRO'
	sku: 'simple_premium_1w_4_99_4w_52_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_O0Lpe2DEV2jM3vFTj'
			amount: 26
			amount_usd: 4.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.99
			discount: 21.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_dsq762DEV2tTFXr2m'
			amount: 52
			amount_usd: 52
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_lFznPiNLXdRO, SubscriptionProduct>
const prd_lFznPiNLXdRO = { ident: 'prd_lFznPiNLXdRO' } as typeof _prd_lFznPiNLXdRO

export default prd_lFznPiNLXdRO
